import { createElement, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { venusParams } from '../../utils/formatImage';
import { locationIconImage, MAGIC_COUPLE_ICON, TAG_IMAGE_MAP } from '../../utils/constants';
import { formatPrice } from '../../utils/formatPrice';
import { jumpToDetail } from '../../utils/jumpUtils';
import { useEffect } from '@max/max';
const isMRN = false;
import { getSystemInfoSync } from '@max/meituan-uni-system';
import './doublecardstyle.scss';
import { isWeb } from '@msi/channel-basic';
const DoubleCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { goodInfo, index, supplyGroupId, pageSourceType, _LXReport, customBtnText } = props;
    const { platform } = getSystemInfoSync() || {};
    const isAndroid = platform === 'android';
    const match = /\d+/;
    const { mvReport, mcReport } = _LXReport;
    const jumpDetail = () => {
        jumpToDetail({
            goodInfo,
            index,
            supplyGroupId,
            pageSourceType,
            mcReport
        });
    };
    const handleView = () => {
        mvReport('b_daodian_lowcode_7s2beos5_mv', {
            valLab: {
                deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
                biz_line: 'holiday',
                dealgroup_id: supplyGroupId,
                item_index: index
            }
        });
    };
    // 格式化促销金额，处理异常格式如 ' .00 '
    const formatPromotionAmount = (amount) => {
        if (!amount)
            return '0';
        // 如果是字符串，先去除空格
        const cleanAmount = typeof amount === 'string' ? amount.trim() : amount;
        // 处理以点开头的情况，如 '.00'
        const normalizedAmount = String(cleanAmount).replace(/^\s*\./, '0.');
        // 转换为数字
        const numAmount = Number(normalizedAmount);
        // 如果是非法数字，返回0
        if (isNaN(numAmount))
            return '0';
        // 如果是整数，直接返回
        if (Number.isInteger(numAmount))
            return String(numAmount);
        // 保留两位小数，去除末尾的0
        return numAmount.toFixed(2).replace(/\.?0+$/, '');
    };
    useEffect(() => {
        handleView();
    }, []);
    //  1006团购。 1007跟团预订
    const isGroupPurchase = useMemo(() => {
        var _a;
        return (_a = String(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId)) === null || _a === void 0 ? void 0 : _a.startsWith('1006');
    }, [goodInfo]);
    // 团购->自由行 - isGroupTour
    const isGroupTour = useMemo(() => {
        var _a;
        return (_a = String(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId)) === null || _a === void 0 ? void 0 : _a.startsWith('1007');
    }, [goodInfo]);
    const actualPrice = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.payPrice) !== null && _b !== void 0 ? _b : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.sellPrice;
    const calcSellFontSize = (str) => {
        if ((str === null || str === void 0 ? void 0 : str.length) <= 3) {
            return '36rpx';
        }
        else {
            return '28rpx';
        }
    };
    const calcLineFontSize = (str) => {
        if ((str === null || str === void 0 ? void 0 : str.length) <= 3) {
            return '24rpx';
        }
        else {
            return '20rpx';
        }
    };
    const calcMarginTop = (str) => {
        if ((str === null || str === void 0 ? void 0 : str.length) <= 3) {
            if (isWeb) {
                return '8rpx';
            }
            else if (isAndroid) {
                return '10rpx';
            }
            else {
                return '0rpx';
            }
        }
        else {
            if (isWeb) {
                return '16rpx';
            }
            else if (isAndroid) {
                return '10rpx';
            }
            else {
                return '10rpx';
            }
        }
    };
    const findTagIconDetail = (categoryLabel) => {
        if (!categoryLabel)
            return null;
        const matchedKey = Object.keys(TAG_IMAGE_MAP).find(key => TAG_IMAGE_MAP[key].title === categoryLabel);
        return matchedKey ? TAG_IMAGE_MAP[matchedKey] : null;
    };
    const currentTagIcon = findTagIconDetail(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryLabel);
    const categoryTagKey = isGroupPurchase ? 3 : 2;
    const categoryTag = (_d = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _c === void 0 ? void 0 : _c.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === categoryTagKey)) === null || _d === void 0 ? void 0 : _d.descriptions;
    const productTag = (_f = (_e = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _e === void 0 ? void 0 : _e.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _f === void 0 ? void 0 : _f.descriptions;
    const showProductTag = (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.length) > 0 ? productTag === null || productTag === void 0 ? void 0 : productTag.slice(0, 3) : productTag;
    const calcTagWidth = (str) => {
        const width = str.length * 20 + 12; // 字号20 左右边距各为6
        return width;
    };
    const productTags = useMemo(() => {
        var _a, _b;
        let allTags = [];
        const productTag = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _a === void 0 ? void 0 : _a.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _b === void 0 ? void 0 : _b.descriptions;
        if (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.groupSizeTag) {
            allTags = [goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.groupSizeTag, ...productTag === null || productTag === void 0 ? void 0 : productTag.slice(0, 3)];
        }
        else {
            allTags = [...productTag];
        }
        const calcCount = () => {
            let sum = 0;
            let count = 0;
            // 可用宽度320 设计稿, tag之间间距6，最好是减去2个6.所以最后可用宽度为：302
            const allTagsWidth = allTags.map(item => calcTagWidth(item));
            for (let i = 0; i < allTagsWidth.length; i++) {
                if (sum + allTagsWidth[i] <= 302) {
                    count++;
                    sum += allTagsWidth[i];
                    continue;
                }
                else {
                    break;
                }
            }
            return count;
        };
        const count = calcCount();
        return allTags === null || allTags === void 0 ? void 0 : allTags.slice(0, count);
    }, [goodInfo, isGroupPurchase, isGroupTour]);
    const isZoreTravelDay = isGroupTour && ((goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay) && Number((_h = (_g = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay) === null || _g === void 0 ? void 0 : _g.match(match)) === null || _h === void 0 ? void 0 : _h[0]) === 0 || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay) === null);
    const isZoreTravelNight = isGroupPurchase && ((goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelNight) && Number((_k = (_j = String(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelNight)) === null || _j === void 0 ? void 0 : _j.match(match)) === null || _k === void 0 ? void 0 : _k[0]) === 0 || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelNight) === null);
    const renderDiscountTag = () => {
        // isGroupTour 1007-提前定- .   isGroupDeal 1006 -比单买省/神券
        var _a, _b, _c, _d;
        if (isGroupTour) {
            if ((goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.advanceDiscountTag) && !(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.advanceDiscountTag) && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag)) {
                // return <Text className="double-card-text-3">{`提前定${goodInfo?.advanceDiscountTag}折`}</Text>
                return <Text className="double-card-text-3">{`${(_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.advanceDiscountTag) === null || _a === void 0 ? void 0 : _a.replace(/\s/g, '')}`}</Text>;
            }
            if (!(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.advanceDiscountTag) && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag)) {
                return <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: '28rpx'
                }}>
          <Image resizeMode="contain" source={{
                    uri: MAGIC_COUPLE_ICON
                }} style={{
                    width: '48rpx',
                    height: '28rpx'
                }}/>
          <Text className="double-card-text-3">{`${goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag}`}</Text>
        </View>;
            }
            return null;
        }
        if (isGroupPurchase) {
            let amount = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) && Number(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) || 0;
            let couponeCount = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) && Number((_b = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag.match(match)) === null || _b === void 0 ? void 0 : _b[0]) || 0;
            if ((goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) && !(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) && amount > couponeCount) {
                return <Text className="double-card-text-3">{`比单买省${goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount}元`}</Text>;
            }
            if (!(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) && amount <= couponeCount) {
                const isMagicCoupon = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) === null || _c === void 0 ? void 0 : _c.startsWith('神券');
                const MagicCouponText = (_d = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) === null || _d === void 0 ? void 0 : _d.split("神券")[1];
                const renderText = isMagicCoupon ? MagicCouponText : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag;
                return <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: '28rpx'
                }}>
          {isMagicCoupon && <Image resizeMode="contain" source={{
                    uri: MAGIC_COUPLE_ICON
                }} style={{
                    width: '48rpx',
                    height: '28rpx'
                }}/>}
          <Text className="double-card-text-3">{`${renderText}`}</Text>
        </View>;
            }
            return null;
        }
    };
    const spaceContent = isMRN ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0';
    return <View className="double-card-container-double" onClick={() => {
        jumpDetail();
    }}>
      <View className="double-card-image-view">
        <Image className="double-card-image" source={{
        uri: venusParams(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsHeadPhoto, 345, 258)
    }}/>
      </View>
      <View className="double-tag-container">
        <View className="double-tag-container-relative">
          <Image className="double-tag-container-tags" source={{
        uri: currentTagIcon === null || currentTagIcon === void 0 ? void 0 : currentTagIcon.image
    }} style={{
        width: (currentTagIcon === null || currentTagIcon === void 0 ? void 0 : currentTagIcon.width) + 'rpx',
        height: '36rpx'
    }}/>
          {isGroupTour && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.departures) && goodInfo.departures.length > 0 && <View className="double-departures-dev" style={{
        paddingLeft: (currentTagIcon === null || currentTagIcon === void 0 ? void 0 : currentTagIcon.width) + 'rpx'
    }}>
              <View className="double-departures-container">
                <Text className="double-departures-text">
                  {goodInfo.departures.length > 1 ? '多地出发' : `${((_l = goodInfo.departures[0]) === null || _l === void 0 ? void 0 : _l.cityName) || 'X X'}出发`}
                </Text>
              </View>
            </View>}
        </View>
      </View>

      <View className="double-rate-location-box-container">
        {isGroupTour ? <View className="double-rate-container">
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.rating) && Number(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.rating) !== 0 && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.rating) !== '0.0' ? <Text className="double-rate-score" style={{
        lineHeight: isMRN ? '24rpx' : '20rpx'
    }}>{`${Number(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.rating)}分`}</Text> : <></>}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.soldCountDisplay) && ((goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId) === 100701 || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId) === 100702) ? <Text className="double-rate-count" style={{
        lineHeight: isMRN ? '24rpx' : '20rpx'
    }}>{(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId) === 100701 ? `月售${goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.soldCountDisplay}` : `年售${goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.soldCountDisplay}`}</Text> : <></>}
          </View> : <></>}
        {isGroupPurchase && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.poiName) ? <View className="double-location-container">
           <Image source={{
        uri: locationIconImage
    }} style={{
        width: '24rpx',
        height: '24rpx'
    }} resizeMode="contain"/>
            <View style={{
        maxWidth: '276rpx',
        overflow: 'hidden',
        marginLeft: '6rpx'
    }}>
              <Text className="double-location-text" numberOfLines={1} style={{
        lineHeight: isMRN ? '24rpx' : '20rpx'
    }}>
                {goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.poiName}
              </Text>
            </View>
          </View> : <></>}
      </View>
      <View className="double-card-content-right">
        <View className="double-card-top-field">
          <View className="double-card-tag-field">
            <View className="double-card-deal-name">
              {isGroupPurchase && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelNight) && !isZoreTravelNight && <View className="double-card-day-h5-tag-view">
                  <Text className="double-card-day-h5-tag-text" style={isMRN ? {
        marginTop: '12rpx'
    } : {}}>{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelNight}</Text>
                </View>}
              {isGroupTour && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay) && !isZoreTravelDay && <View className="double-card-day-h5-tag-view">
                  <Text className="double-card-day-h5-tag-text" style={isMRN ? {
        marginTop: '12rpx'
    } : {}}>{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay}</Text>
                </View>}
              <Text className="double-card-deal-name-text" numberOfLines={2}>
                {isGroupTour && !isZoreTravelDay || isGroupPurchase && !isZoreTravelNight ? spaceContent : ""}
                {goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsName}
              </Text>
            </View>
          </View>
          <View className="double-card-tag">
            {productTags === null || productTags === void 0 ? void 0 : productTags.map((item) => {
        return <View className="double-card-product-tag-group">
                    <Text className="double-card-product-tag-text-group" style={{
            lineHeight: isMRN ? '26rpx' : '20rpx'
        }}>{item}</Text>
                  </View>;
    })}
          </View>
        </View>

        <View className="double-card-bottom-field">
          <View className="double-card-bottom-left-field">
            <View className="double-card-price-now">
              <Text className="double-card-price-icon">¥</Text>
              <Text className="double-card-price-price" style={{
        fontSize: isGroupTour ? calcSellFontSize(formatPrice(actualPrice)) : '36rpx',
        paddingTop: isGroupTour ? calcMarginTop(formatPrice(actualPrice)) : 0
    }}>{formatPrice(actualPrice)}</Text>
              <Text className="double-card-price-text-piece">{isGroupTour ? '起/人' : ''}</Text>
              {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice) !== actualPrice && <Text className="double-card-price-origin" style={{
        fontSize: isGroupTour ? calcLineFontSize(formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice)) : '24rpx'
    }}>
                  {`¥${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice)}`}</Text>}
            </View>

            <View className="double-card-discount-container" style={{
        display: (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.advanceDiscountTag) || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.magicalMemberCouponTag) || (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.saveAmount) ? 'flex' : 'none'
    }}>
              <View className="double-card-bg-color-container-2">
                {renderDiscountTag()}
              </View>
            </View>
          </View>

          <View className="double-card-bottom-right-field">
            <LinearGradient start={{
        x: 0.067,
        y: 0.75
    }} end={{
        x: 0.933,
        y: 0.25
    }} colors={['#FF7700', '#FF4B10']} style={{
        height: '60rpx',
        width: '104rpx',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
              <Text className="double-card-bottom-right-text">{customBtnText}</Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </View>;
};
export default DoubleCard;
